import React,{Component} from 'react';
import axios from 'axios';
import './fil.css';
const allurl = "https://bwapi.onrender.com/filtercat"
const url ="https://bwapi.onrender.com/bikes"
//https://bikeswale.herokuapp.com/bikes?brand=7

class CategoryFilter extends Component {
    filterCategory=(event)=>{
        let categoryId = sessionStorage.getItem('categoryId')

        let category = this.props.category;
        let Brand_id = event.target.value;
        let brandUrl;
        
        if(Brand_id === ''){
            brandUrl = `${allurl}/${category}`
        }else{
            brandUrl= `${allurl}/${categoryId}?brandId=${Brand_id}`
        }
        axios.get(brandUrl)
        .then((res)=>{
            this.props.categoryPerFilter(res.data)
        })

    }
    render(){
        return(
            <>
                <h6 class="fw-bold">Brands</h6>
                <div class="py-2 border-bottom ccc ml-3" onChange={this.filterCategory}>
                    <label className="radio">
                        <input type="radio" name="category" value=""/>All
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="1"/>BMW
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="2"/>Suzuki
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="3"/>Honda
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="4"/>TVS
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="5"/>Vespa
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="6"/>Hero
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="7"/>Yamaha
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="8"/>Keeway
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="9"/>Aprilia
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="10"/>Triumph
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="11"/>Ducati
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="12"/>Kawasaki
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="13"/>Royal Enfield
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="14"/>Java
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="15"/>Harley Davidson
                    </label>
                    <label className="radio">
                        <input type="radio" name="category" value="16"/>Bajaj
                    </label>
                    
                </div>
            </>
        )
    }
}
export default CategoryFilter;